import React from "react";
import UlLi, { scrollTo, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon} from "react-bootstrap";
import { Navigation, Link } from "react-router";
import UserHandler from "js/utilities/user-handler";
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import { ZOOM_ICON } from "js/config.jsx";


// BASH/CURL code Examples
import TEST_CONNECTION_CURL from "resources/code/standard-server/bash/test-connection.bash.tpl";
import SESSION_TOKEN_CURL from "resources/code/standard-server/bash/session-token.bash.tpl";
import ENROLLMENT_POST_CURL from "resources/code/standard-server/bash/enrollment-post.bash.tpl";
import ENROLLMENT_GET_FACEMAP_CURL from "resources/code/standard-server/bash/enrollment-get-facemap.bash.tpl";
import ENROLLMENT_DELETE_CURL from "resources/code/standard-server/bash/enrollment-delete.bash.tpl";
import FACEMAP_POST_CURL from "resources/code/standard-server/bash/facemap-post.bash.tpl";
import LIVENESS_CURL from "resources/code/standard-server/bash/liveness.bash.tpl";
import COMPARE_CURL from "resources/code/standard-server/bash/compare.bash.tpl";
import COMPARE_CURL_3D_2D from "resources/code/standard-server/bash/compare-3d-2d.bash.tpl";
import SEARCH_CURL from "resources/code/restsdk-v2/bash/search.bash.tpl";
import ID_CHECK_CURL from "resources/code/standard-server/bash/id-check.bash.tpl";
import AGE_CHECK_CURL from "resources/code/restsdk-v2/bash/age-check.bash.tpl";
import ESTIMATE_AGE_CURL from "resources/code/restsdk-v2/bash/estimate-age.bash.tpl";

// Node Code Examples
import TEST_CONNECTION_NODEJS from "resources/code/restsdk-v2/nodejs/test-connection.js.tpl";
import SESSION_TOKEN_NODEJS from "resources/code/standard-server/nodejs/session-token.js.tpl";
import ENROLLMENT_POST_NODEJS from "resources/code/standard-server/nodejs/enrollment-post.js.tpl";
import ENROLLMENT_GET_FACEMAP_NODEJS from "resources/code/standard-server/nodejs/enrollment-get-facemap.js.tpl";
import ENROLLMENT_DELETE_NODEJS from "resources/code/standard-server/nodejs/enrollment-delete.js.tpl";
import FACEMAP_POST_NODEJS from "resources/code/standard-server/nodejs/facemap-post.js.tpl";
import LIVENESS_NODEJS from "resources/code/standard-server/nodejs/liveness.js.tpl";
import COMPARE_NODEJS from "resources/code/standard-server/nodejs/compare.js.tpl";
import COMPARE_NODEJS_3D_2D from "resources/code/standard-server/nodejs/compare-3d-2d.js.tpl";
import SEARCH_NODEJS from "resources/code/restsdk-v2/nodejs/search.js.tpl";
import ID_CHECK_NODEJS from "resources/code/standard-server/nodejs/id-check.js.tpl";
import AGE_CHECK_NODEJS from "resources/code/restsdk-v2/nodejs/age-check.js.tpl";
import ESTIMATE_AGE_NODEJS from "resources/code/restsdk-v2/nodejs/estimate-age.js.tpl";

// Success Response Examples
import TEST_CONNECTION_RESPONSE_SUCCESS_JSON from "resources/code/standard-server/response/success/test-connection.json.tpl";
import SESSION_TOKEN_RESPONSE_SUCCESS_JSON from "resources/code/standard-server/response/success/session-token.json.tpl";
import ENROLLMENT_POST_RESPONSE_SUCCESS_JSON from "resources/code/standard-server/response/success/enrollment-post.json.tpl";
import ENROLLMENT_GET_FACEMAP_RESPONSE_SUCCESS_JSON from "resources/code/standard-server/response/success/enrollment-get-facemap.json.tpl";
import ENROLLMENT_DELETE_RESPONSE_SUCCESS_JSON from "resources/code/standard-server/response/success/enrollment-delete.json.tpl";
import FACEMAP_POST_RESPONSE_SUCCESS_JSON from "resources/code/restsdk-v2/response/success/facemap-post.json.tpl";
import LIVENESS_RESPONSE_SUCCESS_JSON from "resources/code/standard-server/response/success/liveness.json.tpl";
import COMPARE_RESPONSE_SUCCESS_JSON from "resources/code/standard-server/response/success/compare.json.tpl";
import COMPARE_RESPONSE_SUCCESS_3D_2D_JSON from "resources/code/standard-server/response/success/compare3d2d.json.tpl";
import SEARCH_RESPONSE_SUCCESS_JSON from "resources/code/restsdk-v2/response/success/search.json.tpl";
import ID_CHECK_RESPONSE_SUCCESS_JSON from "resources/code/standard-server/response/success/id-check.json.tpl";
import AGE_CHECK_RESPONSE_SUCCESS_JSON from "resources/code/restsdk-v2/response/success/age-check.json.tpl";
import ESTIMATE_AGE_RESPONSE_SUCCESS_JSON from "resources/code/restsdk-v2/response/success/estimate-age.json.tpl";

// Failure Response Examples
import ENROLLMENT_POST_RESPONSE_FAILURE_JSON from "resources/code/standard-server/response/failure/enrollment-post.json.tpl";
import ENROLLMENT_GET_FACEMAP_RESPONSE_FAILURE_JSON from "resources/code/standard-server/response/failure/enrollment-get-facemap.json.tpl";
import FACEMAP_POST_RESPONSE_FAILURE_JSON from "resources/code/restsdk-v2/response/failure/facemap-post.json.tpl";
import LIVENESS_RESPONSE_FAILURE_JSON from "resources/code/restsdk-v2/response/failure/liveness.json.tpl";
import COMPARE_RESPONSE_FAILURE_JSON from "resources/code/standard-server/response/failure/compare.json.tpl";
import COMPARE_RESPONSE_FAILURE_3D_2D_JSON from "resources/code/standard-server/response/failure/compare3d2d.json.tpl";
import SEARCH_RESPONSE_FAILURE_JSON from "resources/code/restsdk-v2/response/failure/search.json.tpl";
import ID_CHECK_RESPONSE_FAILURE_JSON from "resources/code/standard-server/response/failure/id-check.json.tpl";
import AGE_CHECK_RESPONSE_FAILURE_JSON from "resources/code/restsdk-v2/response/failure/age-check.json.tpl";
import ESTIMATE_AGE_RESPONSE_FAILURE_JSON from "resources/code/restsdk-v2/response/failure/estimate-age.json.tpl";

import SDKSidebar from "js/utilities/sdk-sidebar"

export default React.createClass({
  displayName: "webservice-guide",
  scrollToGuide : null,
  scrollingEl : null,
  getInitialState: function() {
    var data  = [{name: "Introduction"},
                 {name: "Basic Usage"},
                 {name: "Test Your Connection"},
                 {name: "Security"},
                 {name: "Enrollment CRUD"},
                 {name: "Creating 2D Single Image FaceMaps"},
                 {name: "Liveness Detection"},
                 {name: "3D Face Matching"},
                 {name: "Face Search"},
                 {name: "ID Check"},
                 {name: "Age Check"},
                 {name: "Estimate Age"},
        ];

    var scrollToElement = initDeepLinkData(this.props);

    return {
            data: data,
            navMenuParent: null,
            navMenu: null,
            scrollToElement: scrollToElement
          };
  },

  componentDidMount: function() {
    mountCode(this);
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function() {

    const appToken = "INSERT_APP_TOKEN_HERE";
    const serverToken = "INSERT_SERVER_TOKEN_HERE";

    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container webservice-documentation">

              <section>
                <div className="title">
                  <Glyphicon glyph="list" />
                  <h2 id="zoom-server-rest-api">FaceTec Standard Server REST API</h2>
                </div>
                <p>The FaceTec Standard Server SDK creates REST endpoints that are similar to the FaceTec Testing API and REST Sample Code.  The FaceTec Standard Server SDK APIs have been stripped down to prescriptive behaviors and is tailored to be used in tandem with the FaceTec Server Dashboard.</p>
                <blockquote>Draft Documentation Note:  This page is in the process of being updated and may contain discrepencies from the latest release.  For working code samples, please see the Sample Apps.</blockquote>
                <hr/>
              </section>

              <section>
                <h3 id="basic-usage">Basic Usage</h3>
                <h4 id="basic-usage-url">URL</h4>
                <p>The <code>config.yaml</code> can be used to specify custom ports and base URLs.  The default when development locally is <code>http://localhost:8080</code>.  When deployed remotely, specify the URL of your server instead of localhost,</p>

                <h4 id="basic-usage-accepted-request-types">Accepted Request Types</h4>
                <p>POST requests are accepted when sending content-type: <code>application/json</code></p>

                <h4 id="populating-dashboard-fields">Populating Dashboard Fields</h4>
                
                <p>
                  FaceTec Server Dashboard REQUIRES that data is assembled into your Database in a specific way in order to function properly.  Missing fields, or explicitly removing fields is NOT supported and may cause your Dashboard to break due to lacking data that is expected to be there.  This data is populated by setting specific HTTP Headers to specific values.  Please see the <Link to="/standard-server-and-dashboard">Populating Dashboard Fields Section of the Standard Server & Dashboard Guide</Link> for more information.
                </p>
                <p></p>
              </section>

              <hr />

              <section>
                <h3 id="test-your-connection">Test your connection</h3>
                <p className="section-endpoint"><code>GET /status</code></p>

                <p><strong>Sample Request:</strong></p>
                <div className="code-container">
                  <CodeBlocks curl={TEST_CONNECTION_CURL({appToken})} node={TEST_CONNECTION_NODEJS({appToken})} />
                </div>

                <p><strong>Sample Response:</strong></p>
                <div className="code-container">
                    <CodeBlocks success={TEST_CONNECTION_RESPONSE_SUCCESS_JSON()} />
                </div>
                <p></p>
              </section>

              <section>
                <h3 id="test-your-connection">Session Token</h3>
                <p className="section-endpoint"><code>GET /session-token</code></p>

                <p>Generates an encrypted, signed piece of data called a Session Token, that gets taken in as the input to the device-side Liveness Check launch code. Please see the <Link to="/session-tokens">Session Tokens</Link> Guide for more information.</p>

                <p><strong>Sample Request:</strong></p>
                <div className="code-container">
                  <CodeBlocks curl={SESSION_TOKEN_CURL({appToken})} node={SESSION_TOKEN_NODEJS({appToken})} />
                </div>

                <p><strong>Sample Response:</strong></p>
                <div className="code-container">
                    <CodeBlocks success={SESSION_TOKEN_RESPONSE_SUCCESS_JSON()} />
                </div>
                <p></p>
              </section>

              <section>
                <h3 id="liveness-detection">Liveness Detection</h3>
                <p className="section-endpoint"><code>POST /liveness</code></p>

                <p><strong>Description:</strong></p>
                <p>Performs a Liveness Check on a <code>FaceMap</code>.</p>

                <p>FaceTec Standard Server SDK performs iBeta/NIST/ISO Certified Liveness Detection on every FaceTec 3D FaceMap that is processed.  A single Liveness Status is given for each Liveness Check, and is also reported back for each Authentication.</p>
                <p>Liveness Status is not reported and/or are not valid for:</p>
                <ul>
                  <li><p>2D Single Image FaceMaps -- 2D Single Image do not contain enough data to make a strong Liveness determination.</p></li>
                  <li><p>1:N Search -- 1:N Search is optimized for matching only.</p></li>
                </ul>

                <p><strong>Required Parameters:</strong></p>
                <ul>
                    <li><p><code>faceMap</code></p></li>
                    <li><p><code>auditTrailImage</code>: Captured image from the Liveness Check and provided back to the developer for security and auditing purposes.</p></li>
                    <li><p><code>lowQualityAuditTrailImage</code>: Captured low quality image from the Liveness Check and provided back to the developer for security and auditing purposes.</p></li>
                </ul>

                <p><strong>Sample Request:</strong></p>
                <div className="code-container">
                    <CodeBlocks  curl={LIVENESS_CURL({appToken})} node={LIVENESS_NODEJS({appToken})}  />
                </div>

                <p><strong>Response Data:</strong></p>
                <ul>
                  <li><p><code>glasses</code>: true/false. User of the captured session to be wearing glasses or not. true = User of the captured session was evaluated to be wearing glasses. false = User of the captured session was evaluated to not be wearing glasses.</p></li>
                  <li><p><code>faceMapType</code>: 0/1/2. 0 = 3D FaceMap, 1 = 2D FaceMap, 2 = Unknown.</p></li>
                  <li><p><code>ageResult</code>: 0/1/2/3/4. 0 = Age 13 or over, 1 = Age 16 or over, 2 = Age 18 or over, 3 = Age 21 or over, 4 = Age 25 or over.</p></li>
                  <li><p><code>livenessStatus</code>: 0/1/2. 0 = passed, 1 = undetermined, 2 = undetermined. The FaceTec 3D FaceMap came from a session where there was a live human being if and only if the livenessStatus is 0.</p></li>
                  <li><p><code>auditTrailVerificationCheck</code>: true/false. Indication of whether the Audit Trail Image came from the same session as the FaceMap or not. true = Audit Trail Image came from same FaceMap. false = Audit Trail Image came from a different FaceMap.</p></li>
                  <li><p><code>isLowQuality</code>: true/false. FaceTec Standard Server evaluates session data for face pose, lighting, and many other indicators to assess the quality of the overall capture, this boolean indicates whether Facetec Standard Server evaluated the image(s) to be of poor quality. true = Evaluated as low quality. false = Not evaluated as low quality.</p></li>
                  <li><p><code>tid</code>: Unique identifier.</p></li>
                  <li><p><code>isReplayFaceMap</code>: true/false. Indication of whether a FaceMap was seen by the system already and thus is a replay. true = the FaceMap was a replay. false = the FaceMap was not a replay. </p></li>
                  <li><p><code>auditTrailMatchCheck</code>: true/false. FaceTec Standard Server runs a match of the Audit Trail Image to the Liveness Check to help determine if that the person in the Audit Trail Image matches the person from the FaceMap. true = The Audti Trail Image matches the FaceMap. false = The Audit Trail Image does not match the FaceMap.</p></li>
                </ul>

                <p><strong>Sample Responses:</strong></p>
                <div className="code-container">
                    <CodeBlocks success={LIVENESS_RESPONSE_SUCCESS_JSON()} failure={LIVENESS_RESPONSE_FAILURE_JSON()} />
                </div>
                <p></p>
              </section>

              <section>
                  <h3 id="enrollment-crud">Enrollment CRUD</h3>

                  <h4 id="creating-an-enrollment">Creating an Enrollment</h4>
                  <p className="section-endpoint"><code>POST /enrollment</code></p>
                  <p><strong>Required Parameters:</strong></p>
                  <ul>
                      <li><p><code>enrollmentIdentifier</code>: A unique string to represent this enrollment - user identity.</p></li>
                      <li><p><code>faceMap</code></p></li>
                      <li><p><code>auditTrailImage</code>: Captured image from the Liveness Check and provided back to the developer for security and auditing purposes.</p></li>
                      <li><p><code>lowQualityAuditTrailImage</code>: Captured low quality image from the Liveness Check and provided back to the developer for security and auditing purposes.</p></li>
                  </ul>

                  <p><strong>Sample Request:</strong></p>
                  <div className="code-container">
                      <CodeBlocks curl={ENROLLMENT_POST_CURL({appToken})} node={ENROLLMENT_POST_NODEJS({appToken})} />
                  </div>

                  <p><strong>Response Data:</strong></p>
                  <ul>
                    <li><p><code>glasses</code>: true/false. User of the captured session to be wearing glasses or not. true = User of the captured session was evaluated to be wearing glasses. false = User of the captured session was evaluated to not be wearing glasses.</p></li>
                    <li><p><code>faceMapType</code>: 0/1/2. 0 = 3D FaceMap, 1 = 2D FaceMap, 2 = Unknown.</p></li>
                    <li><p><code>ageResult</code>: 0/1/2/3/4. 0 = Age 13 or over, 1 = Age 16 or over, 2 = Age 18 or over, 3 = Age 21 or over, 4 = Age 25 or over.</p></li>
                    <li><p><code>livenessStatus</code>: 0/1/2. 0 = passed, 1 = undetermined, 2 = undetermined. </p></li>
                    <li><p><code>enrollmentIdentifier</code>: enrollmentIdentifier value which was passed in request parameter. </p></li>
                    <li><p><code>auditTrailVerificationCheck</code>: true/false. Indication of whether the Audit Trail Image came from the same session as the FaceMap or not. true = Audit Trail Image came from same FaceMap. false = Audit Trail Image came from a different FaceMap.</p></li>
                    <li><p><code>isEnrolled</code>: true/false. true = Enrollment Identifier is enrolled. false = Enrollment Identifier is not enrolled. </p></li>
                    <li><p><code>isLowQuality</code>: true/false. FaceTec Standard Server evaluates session data for face pose, lighting, and many other indicators to assess the quality of the overall capture, this boolean indicates whether Facetec Standard Server evaluated the image(s) to be of poor quality. true = Evaluated as low quality. false = Not evaluated as low quality.</p></li>
                    <li><p><code>tid</code>: Unique identifier.</p></li>
                    <li><p><code>auditTrailMatchCheck</code>: true/false. FaceTec Standard Server runs a match of the Audit Trail Image to the Liveness Check to help determine if that the person in the Audit Trail Image matches the person from the FaceMap. true = The Audit Trail Image matches the FaceMap. false = The Audit Trail Image does not match the FaceMap.</p></li>
                    <li><p><code>isReplayFaceMap</code>: true/false. Indication of whether a FaceMap was seen by the system already and thus is a replay. true = the FaceMap was a replay. false = the FaceMap was not a replay. </p></li>
                  </ul>

                  <p><strong>Sample Response:</strong></p>
                  <div className="code-container">
                      <CodeBlocks success={ENROLLMENT_POST_RESPONSE_SUCCESS_JSON()} failure={ENROLLMENT_POST_RESPONSE_FAILURE_JSON()} />
                  </div>

                  <blockquote>
                      <p><strong>Note</strong>: FaceTec will not enroll any FaceMap that doesn&apos;t pass Liveness. This is special behavior of our REST API that can easily be changed if you implement your own. This behavior was chosen by FaceTec to guarantee that any FaceMap that is enrolled meets our standards of a high quality Liveness Check which will benefit authentication and continuous learning.</p>
                  </blockquote>

                  <h4 id="reading-an-enrollment">Reading an Enrollment</h4>
                  <p className="section-endpoint"><code>GET /enrollment/:enrollmentIdentifier</code></p>
                  <p><strong>Required Parameters:</strong></p>
                  <ul>
                      <li><p><code>enrollmentIdentifier</code>: A unique string to represent this enrollment - user identity.</p></li>
                  </ul>

                  <p><strong>Sample Request:</strong></p>
                  <div className="code-container">
                      <CodeBlocks curl={ENROLLMENT_GET_FACEMAP_CURL({appToken})} node={ENROLLMENT_GET_FACEMAP_NODEJS({appToken})} />
                  </div>

                  <p><strong>Response Data:</strong></p>
                  <ul>
                    <li><p><code>enrollmentIdentifier</code>: enrollmentIdentifier value which was passed in request parameter.</p></li>
                    <li><p><code>createDate</code>: Enrollment creation datetime.</p></li>
                    <li><p><code>faceMap</code>: FaceMap data.</p></li>
                    <li><p><code>faceMapType</code>: 0/1/2. 0 = 3D FaceMap, 1 = 2D FaceMap, 2 = Unknown.</p></li>
                    <li><p><code>auditTrailImage</code>: stored auditTrailImage for passed enrollmentIdentifier.</p></li>
                  </ul>

                  <p><strong>Sample Response:</strong></p>
                  <div className="code-container">
                      <CodeBlocks success={ENROLLMENT_GET_FACEMAP_RESPONSE_SUCCESS_JSON()} failure={ENROLLMENT_GET_FACEMAP_RESPONSE_FAILURE_JSON()} />
                  </div>

                  <h4 id="deleting-an-enrollment">Deleting an Enrollment</h4>
                  <p className="section-endpoint"><code>DELETE /enrollment/:enrollmentIdentifier</code></p>

                  <p><strong>Sample Request:</strong></p>
                  <div className="code-container">
                      <CodeBlocks curl={ENROLLMENT_DELETE_CURL({appToken})} node={ENROLLMENT_DELETE_NODEJS({appToken})} />
                  </div>

                  <p><strong>Sample Response:</strong></p>
                  <div className="code-container">
                      <CodeBlocks success={ENROLLMENT_DELETE_RESPONSE_SUCCESS_JSON()} />
                  </div>
                  <p></p>
              </section>

              <section>
                <h3 id="3d-face-matching">Face Matching 3D to 3D</h3>
                <p className="section-endpoint"><code>POST /match-3d-3d</code></p>

                  <p>Perform matching of a <code>source</code> 3D FaceMap against <code>target</code> 3D FaceMap.</p>

                  <p><strong>Required Parameters:</strong></p>
                  <ul>
                      <li><code>source</code>: A source enrollment object that contains the enrollmentIdentifier to match against.
                          <ul>
                              <li><p>Must have this property:<code>enrollmentIdentifier</code></p></li>
                          </ul>
                      </li>
                      <li><code>target</code>: The target object containing a 3D FaceMap to match against.
                          <ul>
                             <li><p>Must have this property:<code>faceMap</code>.</p></li>
                          </ul>
                      </li>
                      <li><p><code>auditTrailImage</code>: Captured image from the Liveness Check and provided back to the developer for security and auditing purposes.</p></li>
                      <li><p><code>lowQualityAuditTrailImage</code>: Captured low quality image from the Liveness Check and provided back to the developer for security and auditing purposes.</p></li>
                  </ul>

                  <blockquote>
                      <p><strong>Important</strong>: The origin of the FaceMaps used for <code>source</code> and <code>target</code> are important when calling matching. The <code>source</code> FaceMap should be the enrollment.  Upon successful Authentication (Match Success and Liveness of both FaceMaps is Proven), the enrollment is updated with the resulting Continuous Learning FaceMap.</p>
                  </blockquote>

                  <p><strong>Sample Request:</strong></p>
                  <div className="code-container">
                      <CodeBlocks curl={COMPARE_CURL({appToken})} node={COMPARE_NODEJS({appToken})} />
                  </div>

                 <p><strong>Response Data:</strong></p>
                 <ul>
                     <li><p><code>sourceFaceMap</code>: Enrollment Identifier for Source FaceMap.</p></li>
                     <li><p><code>matchLevel</code>: FaceTec Standard Server is capable of matching at FAR ranges of up to 1 in 4,200,000.  Please see <Link to="/matching-guide">Matching Guide</Link> for more information on interpreting FaceTec Match Levels.</p></li>
                     <li><p><code>enrollmentIdentifier</code> </p></li>
                     <li><p><code>targetFaceMap</code>: Detail about targetFaceMap.</p></li>
                     <li><p><code>glasses</code>: true/false. User of the captured session to be wearing glasses or not. true = User of the captured session was evaluated to be wearing glasses. false = User of the captured session was evaluated to not be wearing glasses.</p></li>
                     <li><p><code>faceMapType</code>: 0/1/2. 0 = 3D FaceMap, 1 = 2D FaceMap, 2 = Unknown.</p></li>
                     <li><p><code>livenessStatus</code>: 0/1/2. 0 = passed, 1 = undetermined, 2 = undetermined. The FaceTec 3D FaceMap came from a session where there was a live human being if and only if the livenessStatus is 0.</p></li>
                     <li><p><code>auditTrailVerificationCheck</code>: true/false. Indication of whether the Audit Trail Image came from the same session as the FaceMap or not. true = Audit Trail Image came from same FaceMap. false = Audit Trail Image came from a different FaceMap.</p></li>
                     <li><p><code>auditTrailMatchCheck</code>: true/false. FaceTec Standard Server runs a match of the Audit Trail Image to the Liveness Check to help determine if that the person in the Audit Trail Image matches the person from the FaceMap. true = The Audit Trail Image matches the FaceMap. false = The Audit Trail Image does not match the FaceMap.</p></li>
                     <li><p><code>isReplayFaceMap</code>: true/false. Indication of whether a FaceMap was seen by the system already and thus is a replay. true = the FaceMap was a replay. false = the FaceMap was not a replay. </p></li>
                     <li><p><code>message</code>: A description of the status of the Match. </p></li>
                     <li><p><code>tid</code>: Unique identifier. </p></li>
                  </ul>

                  <p><strong>Sample Response:</strong></p>
                  <div className="code-container">
                      <CodeBlocks success={COMPARE_RESPONSE_SUCCESS_JSON()} failure={COMPARE_RESPONSE_FAILURE_JSON()} />
                  </div>
                  <p></p>
              </section>

              <section>
                <h3 id="id-check">ID Check</h3>
                <p className="section-endpoint"><code>POST /id-check</code></p>

                  <p>Match faceMap data with captured Identity Document image</p>

                  <p><strong>Required Parameters:</strong></p>
                  <ul>
                      <li><p><code>enrollmentIdentifier</code></p></li>
                      <li><p><code>idScan</code>: The FaceTec ID Scan.</p></li>
                      <li><p><code>idScanFrontImage</code>: Captured image of the front of the ID from the FaceTec ID Scan and provided back to the developer.</p></li>
                      <li><p><code>idScanBackImage</code>: Captured image of the back of the ID from the FaceTec ID Scan and provided back to the developer.</p></li>
                  </ul>

                  <p><strong>Sample Request:</strong></p>
                  <div className="code-container">
                      <CodeBlocks curl={ID_CHECK_CURL({appToken})} node={ID_CHECK_NODEJS({appToken})} />
                  </div>

                  <p><strong>Response Data:</strong></p>
                  <ul>
                    <li><p><code>glasses</code>:  true/false. User of the captured session to be wearing glasses or not. true = User of the captured session was evaluated to be wearing glasses. false = User of the captured session was evaluated to not be wearing glasses.</p></li>
                    <li><p><code>faceMapAgeEstimateGroup</code>: The estimated age group of the FaceMap. 0 = Age Under 13, 1 = Age Over 13, 2 = Age Over 18, 3 = Age Over 25, 4 = Age Over 30, 5 = Age Over 22.</p></li>
                    <li><p><code>digitalSpoofStatus</code>: 0/1. 0 = Digital Spoof not Detected, 1 = Digital Spoof Detected.</p></li>
                    <li><p><code>matchLevel</code>: Facetec Standard Server is capable of matching at FAR ranges of up to 1 in 4,200,000. Please see <Link to="/matching-guide">Matching Guide</Link> for more information on interpreting FaceTec Match Levels.</p></li>
                    <li><p><code>fullIDStatus</code>: 0/1. 0 = Full ID Detected, 1 = Full ID not Detected.</p></li>
                    <li><p><code>livenessStatus</code>: 0/1/2. 0 = passed, 1 = undetermined, 2 = undetermined. The FaceTec 3D FaceMap came from a session where there was a live human being if and only if the livenessStatus is 0.</p></li>
                    <li><p><code>enrollmentIdentifier</code></p></li>
                    <li><p><code>idScanAgeEstimateGroup</code>: 0/1/2/3/4/5. The estimated age group of the face on the Identity Document. 0 = Age Under 13, 1 = Age Over 13, 2 = Age Over 18, 3 = Age Over 25, 4 = Age Over 30, 5 = Age Over 22.</p></li>
                    <li><p><code>message</code>: A description of the status of the ID Scan.</p></li>
                    <li><p><code>isLowQuality</code>: true/false. FaceTec Standard Server evaluates session data for face pose, lighting, and many other indicators to assess the quality of the overall capture, this boolean indicates whether Facetec Standard Server evaluated the image(s) to be of poor quality. true = Evaluated as low quality. false = Not evaluated as low quality.</p></li>
                    <li><p><code>tid</code>: Unique Identifier. </p></li>
                  </ul>

                  <p><strong>Sample Response:</strong></p>
                  <div className="code-container">
                    <CodeBlocks success={ID_CHECK_RESPONSE_SUCCESS_JSON()} failure={ID_CHECK_RESPONSE_FAILURE_JSON()} />
                  </div>
                  <p></p>
              </section>

              <section>
                <h3 id="3d-2d-face-matching">Face Matching 3D to 2D</h3>
                <p className="section-endpoint"><code>POST /match-3d-2d</code></p>

                  <p>Perform matching of a <code>source</code> 3D FaceMap against <code>target</code> 2D Image.</p>

                  <p><strong>Required Parameters:</strong></p>
                  <ul>
                      <li><code>source</code>: A source enrollment object that contains the enrollmentIdentifier to match against.
                          <ul>
                              <li><p>Must have this property:<code>enrollmentIdentifier</code></p></li>
                          </ul>
                      </li>
                      <li><code>target</code>: The target object containing a 2D Image to match against.  The image must be a base64-encoded JPG or PNG.
                          <ul>
                             <li><p>Must have this property:<code>image</code>.</p></li>
                          </ul>
                      </li>
                  </ul>

                  <blockquote>
                      <p><strong>Important</strong>: The <code>source</code> MUST BE a 3D FaceMap enrollmentIdentifier and <code>target</code> MUST BE base64 JPG or PNG image data.  Continuous Learning is not performed during 3D to 2D Matching.</p>
                  </blockquote>

                  <p><strong>Sample Request:</strong></p>
                  <div className="code-container">
                      <CodeBlocks curl={COMPARE_CURL_3D_2D({appToken})} node={COMPARE_NODEJS_3D_2D({appToken})} />
                  </div>

                 <p><strong>Response Data:</strong></p>
                 <ul>
                     <li><p><code>matchLevel</code>: Match Levels correspond to FAR ranges of up to 1 in 500,000.  Please see <Link to="/matching-guide">Matching Guide</Link> for more information on interpreting FaceTec Match Levels.</p></li>
                     <li><p><code>sourceFaceMap</code>: Enrollment Identifier for Source FaceMap.</p></li>
                     <li><p><code>targetFaceMap</code>: Detail about targetFaceMap.</p></li>
                     <li><p><code>glasses</code>: true/false. User of the captured session to be wearing glasses or not. true = User of the captured session was evaluated to be wearing glasses. false = User of the captured session was evaluated to not be wearing glasses.</p></li>
                     <li><p><code>faceMapType</code>: 0/1/2. 0 = 3D FaceMap, 1 = 2D FaceMap, 2 = Unknown.</p></li>
                     <li><p><code>livenessStatus</code>: 0/1/2. 0 = passed, 1 = undetermined, 2 = undetermined. The FaceTec 3D FaceMap came from a session where there was a live human being if and only if the livenessStatus is 0.</p></li>
                     <li><p><code>isLowQuality</code>: true/false. Facetec Standard Server evaluates session data for face pose, lighting, and many other indicators to assess the quality of the overall capture, this boolean indicates whether Facetec Standard Server evaluated the image(s) to be of poor quality.</p></li>
                  </ul>

                  <p><strong>Sample Response:</strong></p>
                  <div className="code-container">
                      <CodeBlocks success={COMPARE_RESPONSE_SUCCESS_3D_2D_JSON()} failure={COMPARE_RESPONSE_FAILURE_3D_2D_JSON()} />
                  </div>
                  <p></p>
              </section>

              <SDKSidebar menuType="main" title="REST API"/>

            </div>
          </div>
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/standard-server-rest-api.jsx